module.exports = __webpack_public_path__ + "img/logocoto2.7fe82d02.svg";